export function isDevModeHost(hostname?: string): boolean {
  const host = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  return host === 'localhost' || host === '127.0.0.1' || (host.includes('tenant-ai') && !host.includes('tenant-ai-2.oneclicklabs.es'));
}
